<template>
  <v-card flat>
    <v-card-title>
      {{ $t("user.title") }}
      <v-btn icon fab color="color_action" @click="openNewDialog()">
        <v-icon class="display-1"> mdi-plus-circle</v-icon>
      </v-btn>
      <v-spacer />
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            dark
            fab
            @click="onExport()"
            v-bind="attrs"
            v-on="on"
            class="ma-6"
          >
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </template>
        <span>Exporter sous Excel</span>
      </v-tooltip>
    </v-card-title>
    <v-card-subtitle v-if="errorUserCreate || errorUserUpdate">
      <v-alert type="error">
        Erreur lors de la création du compte.<br />
        Les causes possibles sont :
        <ul>
          <li>Compte déjà existant</li>
        </ul>
      </v-alert>
    </v-card-subtitle>
    <v-card-text>
      <v-data-table
        :headers="ligneHeaders"
        :items="users"
        item-key="id"
        :item-class="itemRowClass"
        :search="search"
        @dblclick:row="openEditDialog"
      >
        <template #top="">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Rechercher"
            single-line
            hide-details
            clearable
            class="mb-4"
          />
        </template>
        <template #[`item.dr`]="{ item }">
          <span v-for="(val, i) in item.dr" :key="i">
            {{ getDrName(val) }},
          </span>
        </template>
        <template #[`item.sb`]="{ item }">
          <span v-for="(val, i) in item.sb" :key="i">
            {{ getSbName(val) }},
          </span>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <dialog-user
        v-model="editItem"
        :title="title"
        :nouveau="nouveau"
        :aleat="Math.floor(Math.random() * 1000000)"
        @saveUser="saveUser"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { userMixin } from "@/mixins/user";
import { drMixin } from "@/mixins/dr";
import { structureMixin } from "@/mixins/structure";
import DialogUser from "@/components/DialogUser";
import * as XLSX from "xlsx";

export default {
  name: "VueListUser",
  components: {
    DialogUser,
  },
  mixins: [userMixin, drMixin, structureMixin],
  data() {
    return {
      dialog: false,
      title: "",
      editItem: {},
      nouveau: true,
      search: "",
    };
  },
  computed: {
    ligneHeaders() {
      return [
        {
          text: this.$t("user.prenom"),
          align: "start",
          sortable: true,
          value: "first_name",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("user.nom"),
          align: "start",
          sortable: true,
          value: "last_name",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("user.username"),
          align: "start",
          sortable: true,
          value: "username",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("user.email"),
          align: "start",
          sortable: true,
          value: "email",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("user.dr"),
          align: "start",
          sortable: true,
          value: "dr",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("user.sb"),
          align: "start",
          sortable: true,
          value: "sb",
          class: "color_thead  lighten-2 white--text",
        },
      ];
    },
  },
  mounted() {
    this.getUsers();
    this.getDrs();
    this.getStructs();
  },
  methods: {
    itemRowClass: function (item) {
      return !item.is_active ? "grey--text text--lighten-1" : "";
    },
    openNewDialog() {
      this.dialog = true;
      this.editItem = {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        sb: [],
        dr: [],
        is_active: true,
        is_carte: false,
        is_create_user: false,
        is_cancel_ligne: false,
        is_generate_facture: false,
        second_mail: null,
      };
      this.nouveau = true;
    },
    getDrName(dr) {
      const a = this.drs.find(function (item) {
        return item.id === dr;
      });
      return a ? a.code_safir : null;
    },
    getSbName(sb) {
      const a = this.structs.find(function (item) {
        return item.id === sb;
      });
      return a ? a.libelle : null;
    },
    openEditDialog(event, { item }) {
      this.dialog = true;
      this.editItem = item;
      this.nouveau = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    saveUser(evt, form) {
      Object.keys(form).forEach(function (key) {
        if (key.startsWith("is_")) form[key] = form[key] ?? false;
      });
      if (this.nouveau) {
        this.userCreate({ values: form, list: this.users });
      } else {
        this.userUpdate({ id: form.id, values: form, list: this.users });
      }
      this.closeDialog();
    },
    onExport() {
      let json = [];
      Object.keys(this.users).forEach((key) => {
        json.push({
          Login: this.users[key].username,
          Nom: this.users[key].last_name,
          Prénom: this.users[key].first_name,
          email: this.users[key].email,
          Dr: this.users[key].dr_name,
          Sb: this.users[key].sb_name,
          Active: this.users[key].is_active,
        });
      });
      let ws = XLSX.utils.json_to_sheet(json);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Utilisateurs");
      XLSX.writeFile(wb, "Utilisateurs.xlsx");
    },
  },
};
</script>

<style scoped></style>
